import { useEffect } from "react";

// Mui
import { Grid } from "@mui/material";

// Components
import { Charts } from "./Charts";
import { PathToImprovement } from "./PathToImprovement";

// Hook
import { useLocation } from "react-router-dom";

// Service
import { insightRegisterEvent } from "services";

const ProjectionBody = (): JSX.Element => {
    const { pathname } = useLocation();

    const isBridgeUrl = pathname.includes("bridge");

    useEffect(() => {
        const data = async () => {
            try {
                await insightRegisterEvent();
            } catch (error) {
                console.error(error);
            }
        };
        data();
    }, []);

    return (
        <Grid container sx={{ height: "100%" }}>
            {isBridgeUrl && <PathToImprovement />}
            {!isBridgeUrl && <Charts />}
        </Grid>
    );
};

export default ProjectionBody;
